import { ApproveOrRejectDialog } from "@common/components/ApproveOrRejectDialog";

interface Props {
  onConfirm: (notes?: string) => void;
  isLoading: boolean;
  isApproved: boolean;
  employeeName: string;
  renderTrigger: () => JSX.Element;
}
export const ApproveOrRejectStipendDialog = ({
  isApproved,
  renderTrigger,
  isLoading,
  employeeName,
  onConfirm,
}: Props) => {
  const description = isApproved
    ? `Optionally add a note to let ${employeeName} know why their stipend is being approved.`
    : `Let ${employeeName} know why their stipend is being rejected.`;

  const title = isApproved ? "Approve Stipend" : "Reject Stipend";

  const textareaPlaceholder = isApproved
    ? "Add a note..."
    : "This stipend is out of policy because...";

  return (
    <ApproveOrRejectDialog
      onConfirm={onConfirm}
      isLoading={isLoading}
      isRequired={!isApproved}
      textareaPlaceholder={textareaPlaceholder}
      title={title}
      description={description}
      renderTrigger={renderTrigger}
    />
  );
};
